import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Marketing = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="marketing"
      width={width}
      height={height}
      fill={fill}
      stroke="none"
      className={className}
      viewBox="0 0 25 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M19.5459 10.3321C19.4011 10.0426 19.5184 9.69065 19.808 9.54589L22.1517 8.37402C22.4412 8.22984 22.7932 8.34656 22.9379 8.63609C23.0827 8.92562 22.9654 9.27753 22.6759 9.4223L20.3321 10.5942C20.0397 10.7394 19.69 10.6194 19.5459 10.3321Z" />
      <path d="M22.1517 16.4536L19.808 15.2817C19.5184 15.1369 19.4011 14.785 19.5459 14.4955C19.6918 14.2065 20.0426 14.0904 20.3321 14.2334L22.6759 15.4053C22.9654 15.55 23.0827 15.902 22.9379 16.1915C22.7937 16.4791 22.4439 16.5987 22.1517 16.4536Z" />
      <path d="M22.4136 12.9998H20.0698C19.746 12.9998 19.4839 12.7377 19.4839 12.4138C19.4839 12.09 19.746 11.8279 20.0698 11.8279H22.4136C22.7374 11.8279 22.9995 12.09 22.9995 12.4138C22.9995 12.7377 22.7374 12.9998 22.4136 12.9998Z" />
      <path d="M17.7266 5.38281C17.4027 5.38281 17.1406 5.64488 17.1406 5.96875V6.80539C15.0223 8.16152 12.5272 9.03828 10.0312 9.3402V15.488C12.5272 15.7899 15.0223 16.6666 17.1406 18.0228V18.8594C17.1406 19.1832 17.4027 19.4453 17.7266 19.4453C18.0504 19.4453 18.3125 19.1832 18.3125 18.8594V5.96875C18.3125 5.64488 18.0504 5.38281 17.7266 5.38281Z" />
      <path d="M8.67928 19.5506C8.13975 18.5794 7.67369 17.4387 8.03268 16.4349L5.13904 16.1127C4.92147 16.0886 4.71197 16.0417 4.50818 15.9825C4.07744 17.23 4.11643 18.4573 4.15369 19.3754C4.16287 19.6106 4.17201 19.8304 4.17201 20.0312C4.17201 20.3551 4.43408 20.6172 4.75795 20.6172H8.27357C8.4767 20.6172 8.66553 20.5119 8.77197 20.3391C8.87897 20.1663 8.88869 19.9506 8.79772 19.7691L8.67928 19.5506Z" />
      <path d="M3 12.4141C3 13.7153 3.97504 14.8048 5.2682 14.9484L8.85938 15.3477V9.48047L5.2682 9.8798C3.97504 10.0234 3 11.1129 3 12.4141Z" />
    </svg>
  );
};
/* eslint-enable max-len */

Marketing.defaultProps = {
  className: null,
};

Marketing.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Marketing;
